import { format } from "date-fns";
import { useSelector } from "react-redux";
import { customerIdSelector } from "@/react/features/customer/customerSlice";
import { useLazyGenerateTokenQuery } from "./tokenApi";
import Button from "@8x8/oxygen-button";
import { IconButton } from "@8x8/oxygen-icon-button";
import {
  CardContainer,
  CardsContainer,
  ClaimsBottomCardSectionWrapper,
  TokenBottomCardSectionWrapper,
  TopCardSectionContainer,
  ActionsContainer,
  SmallInput,
} from "./styled";
import { OverlaySpinner } from "@/react/components/OverlaySpinner";
import { CopyButton } from "@/react/components/CopyButton";
import { useMemo, useState } from "react";
import { useErrorNotification } from "@/react/notifications";

const dateOfTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);
  return format(date, "d MMM, H:mm");
};

const TokenGeneratorContent = () => {
  const customerId = useSelector(customerIdSelector);
  const [generateToken, { data, error, isFetching }] =
    useLazyGenerateTokenQuery();
  const [expirationInMinutes, setExpirationInMinutes] = useState(60);
  useErrorNotification(error);

  const hasError = useMemo(() => {
    const value = Number(expirationInMinutes);
    return Number.isNaN(value) || value < 1 || value > 60;
  }, [expirationInMinutes]);

  if (!customerId) {
    return (
      <div>
        No customer selected. Please select a customer to generate a token.
      </div>
    );
  }

  return (
    <>
      {isFetching && (
        <OverlaySpinner data-testid={"token-generator-loading-spinner"} />
      )}
      <ActionsContainer>
        <SmallInput
          prompt={"TTL between 1-60"}
          type={"number"}
          hasError={hasError}
          value={expirationInMinutes}
          onChange={(e) => setExpirationInMinutes(e.target.value)}
          suffix={"min"}
        />
        <Button
          onClick={() =>
            generateToken({
              expirationInSeconds: (expirationInMinutes || 60) * 60,
            })
          }
          isDisabled={hasError}
        >
          {" "}
          Generate Token{" "}
        </Button>
      </ActionsContainer>
      {data?.token && (
        <CardsContainer>
          <CardContainer>
            <TopCardSectionContainer>
              <h5>Encoded</h5>
              <IconButton>
                <CopyButton value={data.token} />
              </IconButton>
            </TopCardSectionContainer>
            <TokenBottomCardSectionWrapper>
              {data.token}
            </TokenBottomCardSectionWrapper>
          </CardContainer>
          <CardContainer>
            <TopCardSectionContainer>
              <h5>Claims</h5>
              <div>Expires at {dateOfTimestamp(data.claimsJson?.exp)}</div>
            </TopCardSectionContainer>
            <ClaimsBottomCardSectionWrapper data-testid={"claims"}>
              {JSON.stringify(data.claimsJson, null, 2)}
            </ClaimsBottomCardSectionWrapper>
          </CardContainer>
        </CardsContainer>
      )}
    </>
  );
};

export default TokenGeneratorContent;
